export interface Work {
  id: number;
  title: string;
  style: string;
  artist: string;
  ratio: 'portrait' | 'landscape';
  tags: string[];
  likes: number;
  updated: string;
  image: string;
}

export const galleryWorks: Work[] = [
  {
    id: 1,
    title: '橘发少女的海风',
    style: '清新水彩',
    artist: '橘猫绘师',
    ratio: 'portrait',
    tags: ['海风', '暖阳', '治愈'],
    likes: 3284,
    updated: '今天',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20anime%20girl%20with%20long%20orange%20hair%20standing%20by%20the%20seaside%20in%20warm%20sunlight%2C%20gentle%20sea%20breeze%20blowing%20her%20hair%2C%20soft%20watercolor%20painting%20style%2C%20warm%20tangerine%20and%20cream%20color%20palette%2C%20tender%20expression%2C%20high%20quality%20anime%20art%2C%20clean%20composition%2C%20soft%20depth%20of%20field&width=800&height=1200&seq=gallery-01&orientation=portrait',
  },
  {
    id: 2,
    title: '夏日冲浪午后',
    style: '明亮插画',
    artist: '浅野阿海',
    ratio: 'portrait',
    tags: ['夏天', '冲浪', '活力'],
    likes: 2756,
    updated: '今天',
    image: 'https://readdy.ai/api/search-image?query=energetic%20anime%20girl%20with%20long%20orange%20hair%20riding%20a%20surfboard%20on%20a%20bright%20summer%20wave%2C%20sunny%20clear%20sky%2C%20vibrant%20bright%20illustration%20style%2C%20warm%20tangerine%20and%20turquoise%20ocean%20tones%2C%20dynamic%20pose%2C%20high%20quality%20anime%20art%2C%20cheerful%20atmosphere%2C%20crisp%20clean%20lines&width=800&height=1200&seq=gallery-02&orientation=portrait',
  },
  {
    id: 3,
    title: '夜空下的守望',
    style: '星夜幻想',
    artist: '星辰屋',
    ratio: 'portrait',
    tags: ['星空', '安静', '梦幻'],
    likes: 4012,
    updated: '昨天',
    image: 'https://readdy.ai/api/search-image?query=anime%20girl%20with%20long%20orange%20hair%20looking%20up%20at%20a%20starry%20night%20sky%20on%20a%20quiet%20hill%2C%20glowing%20stars%20and%20milky%20way%2C%20dreamy%20fantasy%20illustration%2C%20warm%20amber%20and%20deep%20indigo%20night%20tones%2C%20gentle%20contemplative%20mood%2C%20high%20quality%20anime%20art%2C%20magical%20atmosphere&width=800&height=1200&seq=gallery-03&orientation=portrait',
  },
  {
    id: 4,
    title: '橘子汽水与黄昏',
    style: '厚涂写实',
    artist: '暮色画坊',
    ratio: 'portrait',
    tags: ['黄昏', '汽水', '怀旧'],
    likes: 1987,
    updated: '昨天',
    image: 'https://readdy.ai/api/search-image?query=anime%20girl%20with%20long%20orange%20hair%20holding%20a%20glass%20bottle%20of%20orange%20soda%20during%20golden%20hour%20sunset%2C%20warm%20backlight%20glow%2C%20thick%20paint%20semi%20realistic%20style%2C%20nostalgic%20warm%20tones%2C%20rich%20texture%2C%20high%20quality%20anime%20art%2C%20cinematic%20lighting&width=800&height=1200&seq=gallery-04&orientation=portrait',
  },
  {
    id: 5,
    title: '晴空下的漫步',
    style: '清新水彩',
    artist: '麦穗与云',
    ratio: 'portrait',
    tags: ['晴空', '清新', '日常'],
    likes: 2321,
    updated: '3天前',
    image: 'https://readdy.ai/api/search-image?query=anime%20girl%20with%20long%20orange%20hair%20walking%20through%20a%20sunny%20meadow%20with%20clear%20blue%20sky%2C%20soft%20clouds%2C%20light%20watercolor%20style%2C%20fresh%20airy%20warm%20palette%2C%20peaceful%20everyday%20mood%2C%20high%20quality%20anime%20art%2C%20soft%20pastel%20tones%2C%20clean%20composition&width=800&height=1200&seq=gallery-05&orientation=portrait',
  },
  {
    id: 6,
    title: '海岸线与远方',
    style: '厚涂写实',
    artist: '暮色画坊',
    ratio: 'portrait',
    tags: ['海岸', '电影感', '辽阔'],
    likes: 3145,
    updated: '3天前',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20anime%20girl%20with%20long%20orange%20hair%20gazing%20at%20a%20vast%20coastline%20from%20a%20cliff%2C%20wide%20ocean%20and%20distant%20horizon%2C%20semi%20realistic%20thick%20paint%20style%2C%20warm%20golden%20tones%2C%20epic%20film%20atmosphere%2C%20high%20quality%20anime%20art%2C%20dramatic%20warm%20lighting&width=800&height=1200&seq=gallery-06&orientation=portrait',
  },
  {
    id: 7,
    title: '墨色与海浪',
    style: '水墨意境',
    artist: '临海墨客',
    ratio: 'portrait',
    tags: ['水墨', '海浪', '意境'],
    likes: 1654,
    updated: '5天前',
    image: 'https://readdy.ai/api/search-image?query=elegant%20ink%20wash%20painting%20of%20an%20anime%20girl%20with%20long%20orange%20hair%20amidst%20stylized%20waves%2C%20ink%20and%20wash%20chinese%20painting%20style%20with%20splashes%20of%20orange%20and%20vermilion%2C%20zen%20minimalist%20mood%2C%20high%20quality%20art%2C%20poetic%20graceful%20composition%2C%20warm%20paper%20toned%20background&width=800&height=1200&seq=gallery-07&orientation=portrait',
  },
  {
    id: 8,
    title: '糖果色的梦',
    style: '明亮插画',
    artist: '浅野阿海',
    ratio: 'portrait',
    tags: ['甜美', '糖果', '梦境'],
    likes: 2890,
    updated: '5天前',
    image: 'https://readdy.ai/api/search-image?query=sweet%20anime%20girl%20with%20long%20orange%20hair%20in%20a%20dreamy%20candy%20landscape%20with%20floating%20pastel%20shapes%2C%20bright%20cheerful%20illustration%20style%2C%20warm%20pink%20and%20tangerine%20tones%2C%20playful%20whimsical%20mood%2C%20high%20quality%20anime%20art%2C%20colorful%20clean%20composition&width=800&height=1200&seq=gallery-08&orientation=portrait',
  },
  {
    id: 9,
    title: '雨后霓虹街角',
    style: '赛博霓虹',
    artist: '霓虹猫',
    ratio: 'portrait',
    tags: ['霓虹', '雨夜', '赛博'],
    likes: 3567,
    updated: '1周前',
    image: 'https://readdy.ai/api/search-image?query=anime%20girl%20with%20long%20orange%20hair%20standing%20at%20a%20rainy%20neon%20street%20corner%20at%20night%2C%20reflective%20wet%20pavement%2C%20warm%20orange%20and%20magenta%20neon%20glow%20instead%20of%20blue%2C%20cyberpunk%20atmosphere%2C%20high%20quality%20anime%20art%2C%20dramatic%20city%20lighting%2C%20moody%20yet%20warm%20tone&width=800&height=1200&seq=gallery-09&orientation=portrait',
  },
  {
    id: 10,
    title: '海豚与晴空',
    style: '星夜幻想',
    artist: '星辰屋',
    ratio: 'portrait',
    tags: ['海豚', '奇幻', '治愈'],
    likes: 4221,
    updated: '1周前',
    image: 'https://readdy.ai/api/search-image?query=magical%20anime%20girl%20with%20long%20orange%20hair%20swimming%20with%20playful%20dolphins%20under%20a%20clear%20starry%20sky%2C%20fantasy%20dreamy%20illustration%2C%20warm%20amber%20and%20aqua%20tones%2C%20ethereal%20glowing%20atmosphere%2C%20high%20quality%20anime%20art%2C%20wonder%20and%20joy%20mood&width=800&height=1200&seq=gallery-10&orientation=portrait',
  },
  {
    id: 11,
    title: '春日野餐',
    style: '明亮插画',
    artist: '麦穗与云',
    ratio: 'portrait',
    tags: ['春天', '野餐', '温馨'],
    likes: 2113,
    updated: '2周前',
    image: 'https://readdy.ai/api/search-image?query=happy%20anime%20girl%20with%20long%20orange%20hair%20having%20a%20picnic%20in%20a%20blooming%20spring%20park%2C%20cherry%20blossoms%20and%20green%20grass%2C%20bright%20fresh%20illustration%2C%20warm%20sunny%20palette%2C%20cozy%20cheerful%20mood%2C%20high%20quality%20anime%20art%2C%20clean%20welcoming%20composition&width=800&height=1200&seq=gallery-11&orientation=portrait',
  },
  {
    id: 12,
    title: '星尘与罗盘',
    style: '星夜幻想',
    artist: '临海墨客',
    ratio: 'portrait',
    tags: ['罗盘', '星空', '冒险'],
    likes: 2987,
    updated: '2周前',
    image: 'https://readdy.ai/api/search-image?query=adventurous%20anime%20girl%20with%20long%20orange%20hair%20holding%20an%20antique%20compass%20under%20a%20swirling%20starry%20sky%2C%20golden%20and%20amber%20glowing%20light%2C%20fantasy%20illustration%2C%20high%20quality%20anime%20art%2C%20sense%20of%20wonder%20and%20exploration%2C%20warm%20dramatic%20tones&width=800&height=1200&seq=gallery-12&orientation=portrait',
  },
];

export const hotWorks: Work[] = [
  {
    id: 13,
    title: '晴空之下 · 风的方向',
    style: '明亮插画',
    artist: '浅野阿海',
    ratio: 'landscape',
    tags: ['晴空', '风向', '清新'],
    likes: 5120,
    updated: '今天',
    image: 'https://readdy.ai/api/search-image?query=wide%20landscape%20anime%20illustration%20of%20a%20beautiful%20girl%20with%20long%20orange%20hair%20with%20a%20white%20scarf%20flowing%20in%20the%20wind%20on%20a%20sunny%20hill%2C%20vast%20clear%20sky%20and%20rolling%20green%20fields%2C%20bright%20fresh%20warm%20illustration%2C%20high%20quality%20anime%20art%2C%20golden%20sunlight%2C%20cheerful%20peaceful%20mood%2C%20clean%20epic%20composition&width=1200&height=800&seq=hot-01&orientation=landscape',
  },
  {
    id: 14,
    title: '橘子海岸线',
    style: '厚涂写实',
    artist: '暮色画坊',
    ratio: 'landscape',
    tags: ['海岸', '黄昏', '辽阔'],
    likes: 4876,
    updated: '昨天',
    image: 'https://readdy.ai/api/search-image?query=wide%20landscape%20semi%20realistic%20anime%20art%20of%20an%20orange%20haired%20girl%20silhouette%20facing%20a%20glowing%20orange%20sunset%20over%20the%20ocean%2C%20warm%20golden%20and%20tangerine%20sky%20reflecting%20on%20water%2C%20cinematic%20epic%20mood%2C%20thick%20paint%20style%2C%20high%20quality%20anime%20art%2C%20dramatic%20warm%20lighting&width=1200&height=800&seq=hot-02&orientation=landscape',
  },
  {
    id: 15,
    title: '星轨与旅人',
    style: '星夜幻想',
    artist: '星辰屋',
    ratio: 'landscape',
    tags: ['星轨', '夜晚', '梦幻'],
    likes: 4632,
    updated: '3天前',
    image: 'https://readdy.ai/api/search-image?query=wide%20landscape%20fantasy%20anime%20art%20of%20an%20orange%20haired%20girl%20traveling%20under%20a%20night%20sky%20filled%20with%20star%20trails%2C%20milky%20way%20over%20a%20dark%20mountain%20ridge%2C%20warm%20amber%20campfire%20glow%20instead%20of%20blue%2C%20dreamy%20mystical%20atmosphere%2C%20high%20quality%20anime%20art%2C%20sense%20of%20journey%20and%20wonder&width=1200&height=800&seq=hot-03&orientation=landscape',
  },
  {
    id: 16,
    title: '樱色春风',
    style: '清新水彩',
    artist: '麦穗与云',
    ratio: 'landscape',
    tags: ['樱花', '春风', '温柔'],
    likes: 4198,
    updated: '1周前',
    image: 'https://readdy.ai/api/search-image?query=wide%20landscape%20soft%20watercolor%20anime%20art%20of%20an%20orange%20haired%20girl%20under%20falling%20cherry%20blossom%20petals%20in%20spring%20breeze%2C%20gentle%20warm%20pastel%20tones%2C%20delicate%20light%20painting%20style%2C%20tender%20romantic%20mood%2C%20high%20quality%20anime%20art%2C%20ethereal%20soft%20lighting%2C%20poetic%20composition&width=1200&height=800&seq=hot-04&orientation=landscape',
  },
];

export const styleCategories = [
  {
    id: 'fresh',
    name: '清新水彩',
    desc: '通透轻盈的笔触，明亮治愈的氛围，适合做清新系壁纸。',
    works: 286,
    image: 'https://readdy.ai/api/search-image?query=soft%20watercolor%20anime%20art%20of%20an%20orange%20haired%20girl%20with%20translucent%20washes%20and%20light%20pastel%20background%2C%20fresh%20airy%20pastel%20palette%2C%20delicate%20brush%20strokes%2C%20high%20quality%20anime%20art%2C%20gentle%20warm%20light%2C%20clean%20serene%20composition&width=1000&height=620&seq=style-01&orientation=landscape',
  },
  {
    id: 'bright',
    name: '明亮插画',
    desc: '高饱和的明快配色与利落线条，充满元气与活力。',
    works: 342,
    image: 'https://readdy.ai/api/search-image?query=vibrant%20bright%20anime%20illustration%20of%20an%20orange%20haired%20girl%20with%20high%20saturation%20colors%20and%20clean%20bold%20lines%2C%20energetic%20happy%20mood%2C%20sunny%20warm%20palette%2C%20high%20quality%20anime%20art%2C%20dynamic%20cheerful%20composition%2C%20crisp%20graphic%20style&width=1000&height=620&seq=style-02&orientation=landscape',
  },
  {
    id: 'thick',
    name: '厚涂写实',
    desc: '富有质感的厚涂与光影，电影感十足，适合做高清壁纸。',
    works: 198,
    image: 'https://readdy.ai/api/search-image?query=semi%20realistic%20thick%20paint%20anime%20art%20of%20an%20orange%20haired%20girl%20with%20rich%20texture%20and%20dramatic%20warm%20cinematic%20lighting%2C%20detailed%20brushwork%2C%20film%20grade%20tones%2C%20high%20quality%20anime%20art%2C%20deep%20golden%20shadows%2C%20immersive%20mood&width=1000&height=620&seq=style-03&orientation=landscape',
  },
  {
    id: 'neon',
    name: '赛博霓虹',
    desc: '暖色霓虹与都市夜色的碰撞，冷感之外的另一种赛博浪漫。',
    works: 121,
    image: 'https://readdy.ai/api/search-image?query=cyberpunk%20anime%20art%20of%20an%20orange%20haired%20girl%20in%20a%20rainy%20city%20at%20night%20with%20warm%20orange%20and%20magenta%20neon%20lights%2C%20reflective%20wet%20streets%2C%20moody%20tech%20atmosphere%2C%20high%20quality%20anime%20art%2C%20glowing%20signs%2C%20dramatic%20warm%20urban%20lighting&width=1000&height=620&seq=style-04&orientation=landscape',
  },
  {
    id: 'ink',
    name: '水墨意境',
    desc: '东方水墨的留白与写意，以一抹橘色点亮悠远意境。',
    works: 87,
    image: 'https://readdy.ai/api/search-image?query=minimalist%20ink%20wash%20chinese%20painting%20style%20anime%20art%20of%20an%20orange%20haired%20girl%2C%20black%20ink%20and%20subtle%20orange%20vermilion%20accents%2C%20negative%20space%20and%20poetic%20strokes%2C%20warm%20rice%20paper%20background%2C%20high%20quality%20art%2C%20zen%20elegant%20composition&width=1000&height=620&seq=style-05&orientation=landscape',
  },
  {
    id: 'star',
    name: '星夜幻想',
    desc: '星轨、罗盘与魔法元素，把浪漫与冒险藏进银河。',
    works: 154,
    image: 'https://readdy.ai/api/search-image?query=fantasy%20anime%20art%20of%20an%20orange%20haired%20girl%20under%20a%20glowing%20starry%20sky%20with%20shooting%20stars%20and%20soft%20nebula%2C%20warm%20amber%20and%20golden%20tones%2C%20dreamy%20magical%20atmosphere%2C%20high%20quality%20anime%20art%2C%20wonder%20and%20romance%2C%20ethereal%20lighting&width=1000&height=620&seq=style-06&orientation=landscape',
  },
];

export const artists = [
  {
    id: 1,
    name: '橘猫绘师',
    tagline: '清新治愈系 · 主攻水彩与日常',
    works: 128,
    intro: '用通透的笔触记录日常里的光与风，擅长把平凡瞬间画得温柔明亮。',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20watercolor%20anime%20avatar%20portrait%20of%20an%20orange%20haired%20girl%20smiling%20gently%2C%20warm%20cream%20background%2C%20delicate%20brushwork%2C%20high%20quality%20anime%20art%2C%20fresh%20clean%20portrait%20composition&width=400&height=400&seq=artist-01&orientation=portrait',
  },
  {
    id: 2,
    name: '浅野阿海',
    tagline: '明亮元气系 · 高饱和插画',
    works: 96,
    intro: '配色明快、线条利落，擅长把夏日的活力与冲劲画进每一幅作品。',
    avatar: 'https://readdy.ai/api/search-image?query=bright%20colorful%20anime%20avatar%20portrait%20of%20a%20cheerful%20orange%20haired%20girl%2C%20vibrant%20warm%20background%2C%20bold%20clean%20lines%2C%20high%20quality%20anime%20art%2C%20energetic%20happy%20expression%2C%20portrait%20composition&width=400&height=400&seq=artist-02&orientation=portrait',
  },
  {
    id: 3,
    name: '暮色画坊',
    tagline: '厚涂电影感 · 光影与质感',
    works: 74,
    intro: '厚涂与光影见长，每一帧都像电影定格，质感和氛围感并存。',
    avatar: 'https://readdy.ai/api/search-image?query=semi%20realistic%20thick%20paint%20anime%20avatar%20portrait%20of%20an%20orange%20haired%20girl%20in%20golden%20dramatic%20light%2C%20rich%20texture%2C%20cinematic%20warm%20tone%2C%20high%20quality%20anime%20art%2C%20serious%20moody%20expression%2C%20portrait%20composition&width=400&height=400&seq=artist-03&orientation=portrait',
  },
  {
    id: 4,
    name: '星辰屋',
    tagline: '星夜幻想系 · 梦幻与浪漫',
    works: 88,
    intro: '把星空、罗盘与魔法揉进画面，构筑一个个温柔又辽阔的梦境。',
    avatar: 'https://readdy.ai/api/search-image?query=fantasy%20anime%20avatar%20portrait%20of%20an%20orange%20haired%20girl%20with%20glowing%20stars%20around%20her%2C%20dreamy%20warm%20nebula%20background%2C%20ethereal%20magical%20light%2C%20high%20quality%20anime%20art%2C%20wondering%20expression%2C%20portrait%20composition&width=400&height=400&seq=artist-04&orientation=portrait',
  },
  {
    id: 5,
    name: '临海墨客',
    tagline: '水墨意境系 · 东方写意',
    works: 52,
    intro: '以水墨留白绘海与风，一抹橘色点睛，于纸间晕开东方意境。',
    avatar: 'https://readdy.ai/api/search-image?query=ink%20wash%20style%20anime%20avatar%20portrait%20of%20an%20orange%20haired%20girl%2C%20black%20ink%20with%20orange%20vermilion%20accents%20on%20warm%20paper%2C%20minimalist%20poetic%2C%20high%20quality%20art%2C%20zen%20elegant%20portrait%20composition&width=400&height=400&seq=artist-05&orientation=portrait',
  },
  {
    id: 6,
    name: '霓虹猫',
    tagline: '赛博霓虹系 · 都市夜色',
    works: 63,
    intro: '偏爱暖色霓虹与雨夜街头，在冷感都市里画出一片温热的赛博浪漫。',
    avatar: 'https://readdy.ai/api/search-image?query=cyberpunk%20anime%20avatar%20portrait%20of%20an%20orange%20haired%20girl%20with%20warm%20orange%20neon%20glow%20on%20her%20face%2C%20night%20city%20bokeh%20background%2C%20high%20quality%20anime%20art%2C%20moody%20cool%20expression%2C%20portrait%20composition&width=400&height=400&seq=artist-06&orientation=portrait',
  },
];

export const faqs = [
  {
    q: '这里的同人插画可以免费下载吗？',
    a: '可以。本站收录的娜美同人插画与壁纸均支持免费收藏下载，点击作品卡片即可查看大图并保存原图。请仅用于个人收藏与欣赏，商用或转载请先获得原作者授权。',
  },
  {
    q: '图集会多久更新一次？',
    a: '本站每日更新，工作日与周末都会持续收录新的画师作品。订阅「每日更新」后，我们会把当天的新图集第一时间推送到你的邮箱，方便你不错过心仪的美图。',
  },
  {
    q: '如何按风格或角色查找作品？',
    a: '在「最新图集」板块顶部可以选择风格（清新水彩、明亮插画、厚涂写实、赛博霓虹、水墨意境、星夜幻想等）进行筛选，也能按角色与标签定位具体作品。',
  },
  {
    q: '我是一名画师，可以投稿自己的作品吗？',
    a: '非常欢迎！如果你希望自己的娜美同人作品被收录并标注署名展示，可通过页面底部的联系方式与我们取得联系，我们会审核后署名收录，并保证版权归原作者所有。',
  },
  {
    q: '作品的水印与清晰度如何保证？',
    a: '站内预览图会保留作者水印以确保版权，点击放大后可查看较高清的大图。若需下载原图或更高清晰度资源，请参考该作品说明或联系对应画师。',
  },
];